import React from 'react';
import { IconStatsCardComponent } from 'baseComponents/IconStatsCardComponent';
import { StatsElement } from 'types/componentTypes/stats-wrapper-types';
import { formatWithThousandSeparators } from 'utils/formatNumber';
import 'screens/HomeScreen/components/StatsWrapper/statsWrapper.scss';

interface Props {
  statsElements: StatsElement[];
  isLoading?: boolean;
}

export const StatsWrapper: React.FC<Props> = (props) => {
  return (
    <div className='stats-wrapper'>
      {props.statsElements.map((s) => {
        return (
          <IconStatsCardComponent
            key={s.title}
            statsValue={
              s.statsValue ? formatWithThousandSeparators(s.statsValue) : '0'
            }
            title={s.title}
            subtitle={s.subtitle}
            iconType={s.iconType}
            creditWarning={s.creditWarning}
          />
        );
      })}
    </div>
  );
};
